import util from '../util'

let controller = 'CobrancaRecorrente'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall', 'post', 'put', 'persist']), {
  RealizarExtracao: function (search) {
    return util.Axios.GetAll(controller + '/Extracao', search)
  }
})